import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function seniorManagementReducer(state = initialState.seniorManagement, action) {
  switch (action.type) {
    case types.GET_SITE_SENIOR_MANAGEMENT_SUCCESS:
      return action.seniorManagement;
    case types.CLEAR_SITE_SENIOR_MANAGEMENT:
      return initialState.seniorManagement;
    default:
      return state;
  }
}
